import * as React from "react";
const SVGComponent = (props) => (
  <svg
    id="Layer_1"
    data-name="Layer 1"
    xmlns="http://www.w3.org/2000/svg"
    width={256}
    height={256}
    viewBox="0 0 256 256"
    {...props}
  >
    <defs>
      <style>{"\n      .cls-1 {\n        fill: #c88242;\n      }\n    "}</style>
    </defs>
    <path
      className="cls-1"
      d="M244.5,112.2c-1.3-6.3-4.8-12.2-8.7-17.6s-.7-1-.9-1.6c-2.3-5.2-15.2-33.6-31.8-43.2-18.3-10.5-71.5-16.5-71.5-16.5-12.6-2.1-45.7,4.5-56.1,7.7s-.4.1-.6.1c-20.2,4.3-33.5,19.8-43.9,36.7-12.5,20.2-19.6,42.8-20.1,65.7.2-.4.5-.8.7-1.2,2-3.5,5.8-5.8,10.1-7.1s2.6-1.1,3.6-2.1,2.8-2.6,4.4-3.7,2.5-2.2,3.2-3.7,1.6-3.3,2.7-4.8,1.2-2,1.5-3.2c.6-2.5,1.8-4.7,3.8-6.3s2.7-3.1,3-5.1c.5-2.9,1.8-5.6,4.1-7.3s2.7-2.7,3.3-4.5,2.5-4.4,5-5.4,3.5-2.3,4.4-4.2c1.7-3.5,4.9-5.6,8.6-6.2s3.5-1,4.8-2.3l2.5-2.4c1.2-1.1,2.2-4.5,3.9-5,1.1-.3,2.5-.3,3.8-.2s3.5-.2,4.9-1.1,4.1-1.6,6.3-1.2,4.7,0,6.6-1.4,2.2-1.3,3.1-1.4c1.3-.1,2.6.1,3.8.6,2,.8,4.2,1,6.2.3s2.7-.6,4.1-.5,3.5-.3,5-1.3c3.9-2.5,7.1-2.3,11-.3s3.5,1.1,5.3.8,3.6-.5,4.8-.2c.8.2,1.6.9,2.3,1.9,1.2,1.6,2.9,2.7,4.9,2.9s2.9.8,3.8,2,3,2.2,4.8,2.4,1.6.3,2,.7c.5.5,1,1.5,1.4,2.4s1.1,2,2,2.8,1.6,1.9,2,3.1c1.1,3.4,4.6,5.5,8.3,5.5,6.4-.1,12.4,1.7,17.8,5.5,3.1,2.3-2.8,9-10.6,13.5s-5.5,8.4-2.3,12.4c5.8,7.3,10.6,14.9,15.1,23.1,4.4,7.9,8.5,15.5,11.9,23.8,1.7,4.1,1.8,8.2.5,12.3s-.4,1.9-.4,2.9l.3,6.2c.2,3.2-1.5,6-4.4,7.1s-2.7,1.5-3.7,2.7c-5.7,7.5-16.3,8.8-24.9,3.7-4.9-2.9-10-6.5-15.9-7l-8.1-.8c-4.1-.4-7.9,2.3-8.9,6.3s-1.7,9.4-4.4,13.1-1.1,1.9-1.4,3l-1.5,5.9c0,.3-.2.7-.2,1-1.2,5.4,2.9,10.5,8.4,10.3,12.2-.4,24.2-1.6,33.9-4.1,13.8-3.6,25.8-11.3,37-19.6,13.7-10.2,21.4-24.2,23.5-40,.1-1,.3-2,.4-3s.2-.9.3-1.4c3.1-10.1,4.4-20.6,5.4-31.1.6-6.7,1.6-13.5.2-20.1Z"
    />
    <path
      className="cls-1"
      d="M149.7,125c3.8,1.5,3.6,5.6,6.4,7.3,1.8-3.4.9-6-.5-8.9-1.6-3.1-5.3-4.8-8.9-4.1-5.1,1-8.8,7.2-6.6,11.4l4.2-4.4c1.1-1.1,4.1-1.8,5.4-1.2Z"
    />
  </svg>
);
export default SVGComponent;
